import { render, staticRenderFns } from "./DataForm.vue?vue&type=template&id=3b9240ca"
import script from "./DataForm.vue?vue&type=script&lang=js"
export * from "./DataForm.vue?vue&type=script&lang=js"
import style0 from "./DataForm.vue?vue&type=style&index=0&id=3b9240ca&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b9240ca')) {
      api.createRecord('3b9240ca', component.options)
    } else {
      api.reload('3b9240ca', component.options)
    }
    module.hot.accept("./DataForm.vue?vue&type=template&id=3b9240ca", function () {
      api.rerender('3b9240ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/billing/Expense/components/DataForm.vue"
export default component.exports